/**
 * Initials for a person, from a full name ("MJ Nuanes") or first and last name. A first
 * name that is already two initials (MJ, CJ, M.J.) is used as it is, so MJ Nuanes shows
 * "MJ" and not "MN" like Michael Nuanes (Adam, 26 Oct). Same rule as the server.
 */
export function initialsOf(nameOrFirst, last) {
  let first = nameOrFirst;
  if (last === undefined) {
    const words = String(nameOrFirst || '').trim().split(/\s+/);
    first = words[0];
    last = words.length > 1 ? words[words.length - 1] : '';
  }
  const bare = String(first || '').trim().replace(/\./g, '');
  if (/^[A-Z]{2}$/.test(bare)) return bare;
  return [first, last].map((x) => String(x || '').trim()[0] || '').join('').toUpperCase();
}
